// extracted by mini-css-extract-plugin
export var button = "newsFeed-module--button--0541b";
export var dark = "newsFeed-module--dark--0857c";
export var image = "newsFeed-module--image--01e8f";
export var imageContainer = "newsFeed-module--imageContainer--e83c4";
export var imagePlaceholderContainer = "newsFeed-module--imagePlaceholderContainer--0e19c";
export var imageText = "newsFeed-module--imageText--5e2b5";
export var klaviyoLogo = "newsFeed-module--klaviyoLogo--efe7f";
export var light = "newsFeed-module--light--05a99";
export var newsFeed = "newsFeed-module--newsFeed--b1069";
export var newsFeedTitle = "newsFeed-module--newsFeedTitle--bd690";
export var postDate = "newsFeed-module--postDate--ad44b";
export var postLink = "newsFeed-module--postLink--bfa7a";
export var postText = "newsFeed-module--postText--6fad8";
export var postTitle = "newsFeed-module--postTitle--e75c7";
export var textContent = "newsFeed-module--textContent--c72b0";